module.exports = __webpack_public_path__ + "static/media/firebase.1da029b3.webp";